import { CommentDTO } from '../app/core/models/comment-model';

/**
 * Mock-Kommentare.
 * guid entspricht dem neuen API-Format.
 * stage.phase wird zur Ableitung des checkStatus (Kontrolle-Phase) genutzt.
 * author.oid muss einer der OIDs aus DummyFiles/users.ts entsprechen.
 */
export const COMMENT: CommentDTO[] = [
  {
    guid: 'cccccccc-0000-0000-0000-000000000001',
    author: { oid: '11111111-0000-0000-0000-000000000001', displayName: 'A. Meyer' },
    createdAt: '2024-02-10T14:30:00Z',
    modifiedAt: '2024-02-10T14:30:00Z',
    text: 'Die Berechnungsgrundlage für die Tragfähigkeit der Stahlträger im Abschnitt 3.2 muss noch einmal überprüft werden. Die Werte weichen von der DIN-Norm ab.',
    isDone: false,
    severity: 'WARNING',
    stage: { id: 1, createdAt: '2024-02-10T00:00:00Z', status: 'IN_PROGRESS', phase: 'FIRST', dueAt: '2025-03-10T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000002',
    author: { oid: '11111111-0000-0000-0000-000000000002', displayName: 'B. Schulz' },
    createdAt: '2024-02-11T09:15:00Z',
    modifiedAt: '2024-02-11T09:15:00Z',
    text: 'Brandschutznachweis wurde aktualisiert und entspricht jetzt den Anforderungen.',
    isDone: true,
    severity: 'WARNING',
    stage: { id: 1, createdAt: '2024-02-10T00:00:00Z', status: 'IN_PROGRESS', phase: 'FIRST', dueAt: '2025-03-10T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000003',
    author: { oid: '11111111-0000-0000-0000-000000000001', displayName: 'A. Meyer' },
    createdAt: '2024-02-12T10:00:00Z',
    modifiedAt: '2024-02-12T10:00:00Z',
    text: 'Info: Der Auftraggeber hat die geänderten Planungsunterlagen am 08.02. freigegeben.',
    isDone: false,
    severity: 'INFO',
    stage: { id: 2, createdAt: '2024-02-11T00:00:00Z', status: 'IN_PROGRESS', phase: 'SECOND', dueAt: '2025-05-15T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000004',
    author: { oid: '11111111-0000-0000-0000-000000000004', displayName: 'D. König' },
    createdAt: '2024-02-13T11:30:00Z',
    modifiedAt: '2024-02-13T11:30:00Z',
    text: 'Kabelquerschnitte im Schaltplan angepasst – bitte gegenprüfen.',
    isDone: true,
    severity: 'WARNING',
    stage: { id: 2, createdAt: '2024-02-11T00:00:00Z', status: 'IN_PROGRESS', phase: 'SECOND', dueAt: '2025-05-15T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000005',
    author: { oid: '11111111-0000-0000-0000-000000000005', displayName: 'E. Weber' },
    createdAt: '2024-02-14T08:45:00Z',
    modifiedAt: '2024-02-14T08:45:00Z',
    text: 'Info: Entwässerungsplan wurde vom Statiker abgezeichnet.',
    isDone: false,
    severity: 'INFO',
    stage: { id: 3, createdAt: '2024-02-13T00:00:00Z', status: 'CREATED', phase: 'REVIEW', dueAt: '2025-04-10T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000006',
    author: { oid: '11111111-0000-0000-0000-000000000001', displayName: 'A. Meyer' },
    createdAt: '2024-02-14T14:00:00Z',
    modifiedAt: '2024-02-14T14:00:00Z',
    text: 'Info: Rückmeldung vom TÜV steht noch aus, voraussichtlich bis Ende der Woche.',
    isDone: false,
    severity: 'INFO',
    stage: { id: 3, createdAt: '2024-02-13T00:00:00Z', status: 'CREATED', phase: 'REVIEW', dueAt: '2025-04-10T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000007',
    author: { oid: '11111111-0000-0000-0000-000000000002', displayName: 'B. Schulz' },
    createdAt: '2024-02-15T09:30:00Z',
    modifiedAt: '2024-02-15T09:30:00Z',
    text: 'Maßtoleranzen der Fertigteile liegen innerhalb der zulässigen Grenzen.',
    isDone: true,
    severity: 'WARNING',
    stage: { id: 3, createdAt: '2024-02-13T00:00:00Z', status: 'CREATED', phase: 'REVIEW', dueAt: '2025-04-10T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000008',
    author: { oid: '11111111-0000-0000-0000-000000000003', displayName: 'C. Sommer' },
    createdAt: '2024-02-15T16:00:00Z',
    modifiedAt: '2024-02-15T16:00:00Z',
    text: 'Info: Projektbesprechung am 20.02. – bitte alle offenen Punkte bis dahin klären.',
    isDone: false,
    severity: 'INFO',
    stage: { id: 2, createdAt: '2024-02-11T00:00:00Z', status: 'IN_PROGRESS', phase: 'SECOND', dueAt: '2025-05-15T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000009',
    author: { oid: '11111111-0000-0000-0000-000000000004', displayName: 'D. König' },
    createdAt: '2024-02-16T10:15:00Z',
    modifiedAt: '2024-02-16T10:15:00Z',
    text: 'Fehlende Unterschrift auf dem Abnahmeprotokoll – bitte nachholen.',
    isDone: false,
    severity: 'WARNING',
    stage: { id: 2, createdAt: '2024-02-11T00:00:00Z', status: 'IN_PROGRESS', phase: 'SECOND', dueAt: '2025-05-15T00:00:00Z' },
  },
  {
    guid: 'cccccccc-0000-0000-0000-000000000010',
    author: { oid: '11111111-0000-0000-0000-000000000005', displayName: 'E. Weber' },
    createdAt: '2024-02-16T13:45:00Z',
    modifiedAt: '2024-02-16T13:45:00Z',
    text: 'Materialprüfbericht weist Abweichungen bei der Betondruckfestigkeit auf – Nachprüfung erforderlich.',
    isDone: false,
    severity: 'WARNING',
    stage: { id: 3, createdAt: '2024-02-13T00:00:00Z', status: 'CREATED', phase: 'REVIEW', dueAt: '2025-04-10T00:00:00Z' },
  },
];

